'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkStatus = exports.json = undefined;
exports.getAuthorizationHeader = getAuthorizationHeader;
exports.encodeQueryData = encodeQueryData;

var _lodash = require('lodash');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cookie = require('cookie-dough')();

function getAuthorizationHeader() {
  var accessToken = cookie.get(_constants2.default.AUTH_COOKIE_NAME);

  if (accessToken) {
    return {
      'Authorization': 'bearer ' + accessToken
    };
  }
}

function encodeQueryData(data) {
  var ret = [];

  var _loop = function _loop(key) {
    var value = data[key];

    if ((0, _lodash.isArray)(value)) {
      (0, _lodash.forEach)(value, function (element) {
        ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(element));
      });
    } else if (typeof value !== 'undefined') {
      ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  };

  for (var key in data) {
    _loop(key);
  }

  return ret.join('&');
}

var json = exports.json = function json(res) {
  return res.json();
};

var checkStatus = exports.checkStatus = function checkStatus(res) {
  if (res.ok) {
    return res;
  } else {
    return Promise.reject(res);
  }
};